/*eslint-disable*/
import { createGlobalStyle } from 'styled-components';

import { LIGHT_BG_COLOR } from 'constants/Theme';
import { isLightTheme } from 'utils';

const GlobalStyle = createGlobalStyle`
    @media screen and (min-width: 769px) {
      body {
        background: ${(props) =>
          isLightTheme(props) ? LIGHT_BG_COLOR : '#1e2130'} ;
      }
    }`;

export default GlobalStyle;
